import * as React from 'react';
import styled from 'styled-components';
import { DarkGreySidely2, LightGreySidely2, PastelPrimaryColor, PrimaryColor, SidelyBlack } from '../../styles/global/css/Utils';
import { Loader } from '../../styles/global/css/GlobalLoader';
import { translateToString } from '../../styles/global/translate';
import { TOOLBARS_HEIGHT } from '../globals/defaultToolbar/style/Style';
import { AdditionalValuesPath } from '../settings/subSettings/actions';
import { AdditionalValuesView, matchingPath } from './assortmentFieldPage';
import { FlexDiv } from './style';

export const MODAL_LEFT_WIDTH = 260;

const Title = styled.div`
	padding: 16px 16px 6px;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: ${DarkGreySidely2};
`;

const FieldButton = styled.button<{ active: boolean }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	width: calc(100% - 16px);
	margin: 0 8px;
	padding: 7px 8px;
	border: none;
	border-radius: 6px;
	text-align: left;
	font-size: 12px;
	cursor: pointer;
	background-color: ${p => p.active ? PastelPrimaryColor : 'transparent'};
	color: ${p => p.active ? PrimaryColor : SidelyBlack};
	font-weight: ${p => p.active ? 500 : 400};
	&:hover {
		background-color: ${LightGreySidely2};
	}
`;

const FieldName = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const Count = styled.span`
	display: inline-flex;
	align-items: center;
	flex-shrink: 0;
	font-size: 11px;
	color: ${DarkGreySidely2};
`;

function AssortmentModalLeft(props: {
	isModalOpen: boolean,
	paths: AdditionalValuesPath[],
	views: AdditionalValuesView[],
	loading: boolean,
	selectedPathId?: number,
	onSelect: (pathId: number) => void,
}) {
	const { paths, views, selectedPathId, onSelect } = props;
	const entries = React.useMemo(() => {
		const counts = new Map<number, number>();
		for (const view of views) {
			const path = matchingPath(view, paths);
			if (path) counts.set(path.id, (counts.get(path.id) ?? 0) + 1);
		}
		return [...paths]
			.sort((a, b) => a.label.localeCompare(b.label))
			.map(path => ({ id: path.id, label: path.label, count: counts.get(path.id) ?? 0 }));
	}, [paths, views]);

	return <div className='filter-modal' style={{ top: TOOLBARS_HEIGHT, height: `calc(100% - ${TOOLBARS_HEIGHT}px)`, left: '1px' }}>
		<FlexDiv flow='column' align='stretch' gap='4px' className={props.isModalOpen ? 'box-filter-modal' : 'd-none'} style={{ width: `${MODAL_LEFT_WIDTH}px` }}>
			<Title>{translateToString('multidimensional_assortments.title')}</Title>
			{entries.map(entry => <FieldButton key={entry.id} type='button' active={selectedPathId === entry.id} onClick={() => onSelect(entry.id)}>
				<FieldName>{entry.label}</FieldName>
				<Count>{props.loading ? <Loader width='12px' /> : entry.count}</Count>
			</FieldButton>)}
		</FlexDiv>
	</div>;
}

export default React.memo(AssortmentModalLeft);
